module.exports = __webpack_public_path__ + "static/media/bestquote-logo.1c2df910.png";